export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-braille-d63d7410cb847ac21263a17b746ddccf.svg";